export enum UserRole {
  ACCOUNT_MANAGER = 'account_manager',
  SHADOW = 'shadow_engineer',
  MANAGER = 'manager',
  EMPLOYEE = 'employee',
  PARTNER = 'partner',
  CLIENT = 'client',
}

export enum UserType {
  Internal = 'internal',
  External = 'external',
}

export enum Resource {
  CheckIn = 'CheckIn',
  Settings = 'Team',
  YourTeams = 'YourTeams',
  Analytics = 'Analytics',
  Dashboard = 'Dashboard',
  CheckInUsage = 'CheckInUsage',
  CheckInQuality = 'CheckInQuality',
  PerformanceReview = 'PerformanceReview',
  GiveFeedback = 'GiveFeedback',
  Reports = 'Reports',
}

export enum ACTIONS {
  MANAGE = 'manage',
  CREATE = 'create',
  READ = 'read',
  UPDATE = 'update',
  DELETE = 'delete',
}

export const checkInUsageHref = '/analytics/check-in-usage';
export const checkInQualityHref = '/analytics/check-in-quality';

export const BC_AGENTS_URL =
  'https://agents-winter-sun-3220.fly.dev/bc-experience-ai';

export const PRIVACY_POLICY_URL = 'https://beautifulcode.in/privacy-policy';
